import React, { Fragment, useState } from 'react';
import InputText from '../../../fragments/Inputs/InputText';
import { ReactComponent as SideGestionWhite } from '../../../../assets/icons/sideGestionWhite.svg';

const AplicarDescuento = ({styles}) => {
  const [descuento, setDescuento] = useState('');
  return (
    <div className={`${styles}`} >
      <div className='flex'>
        <InputText
          name={'Descuento'}
          label={'Descuento:'}
          placeholder={'Introduce un valor'}
          styles='!w-full bg-gray-200 font-semibold'
          wrapperStyles='!flex items-center gap-x-2'
          labelStyles='!font-light !text-sm'
          value={descuento}
          onChange={(e) => setDescuento(e.target.value)}
        />
      </div>
      <button
        type='button'
        className='w-full sm:w-80 lg:w-fit bg-nimbus hover:bg-nimbusDark text-white font-bold py-2 px-4 rounded-lg flex items-center justify-center'
        disabled={descuento === ''}
      >
        <SideGestionWhite className='w-5 h-5 mr-2' />
        Aplicar descuento
      </button>
    </div>
  );
};

export default AplicarDescuento;
